import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class QuotationService {
  currentInput = signal<string | undefined>(undefined);
  selectValue$ = new Subject<{ id: string; type: string; value: string }>();

  selectValue(value: { id: string; type: string; value: string }) {
    this.selectValue$.next(value);
    this.currentInput.set(undefined);
  }

  watchSelectedValue() {
    this.selectValue$.asObservable();
  }
}
